import DesktopWindowsIcon from "@mui/icons-material/DesktopWindows";
import DesktopWindowsOutlinedIcon from "@mui/icons-material/DesktopWindowsOutlined";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FolderIcon from "@mui/icons-material/Folder";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import {
  Autocomplete,
  Button,
  InputLabel,
  Typography,
  Grid,
  Tab,
  Tabs,
  TextField,
  DialogActions,
  ButtonGroup,
  MenuItem,
  Box,
  CircularProgress,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Checkbox,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import { getUnitPropertie } from "../../../../../containers/smart/camunda/forms/functions";
import { getDocumentoVariables } from "../../../../../containers/smartForms/components/helper";
import { useDocumentTypes } from "../../../../../hooks/documentTypes";
import useTreeFolder from "../../../../../hooks/useTreeFolder";
import { language } from "../../../../../language";
import Provider from "../../../../../Provider";
import { getUniqueDocumentServiceFields } from "../../../../../util/camundaPropertiesPanelUtils";
import Empty from "../../../../Empty";
import Table from "../../../../generic-table";
import GenericModal from "../../../../modal-closebtn/index";
import GenericSnackbar from "../../../../snackbar/generic-snackbar";

const FormPadding = styled("div")(({ theme }) => ({
  padding: "1% 1%",
}));

const DEBUG_REGISTRAR_ARQUIVAR_DOCUMENTO = false;

function debugLog(eventName, payload) {
  if (!DEBUG_REGISTRAR_ARQUIVAR_DOCUMENTO) {
    return;
  }
  console.log("[RegistrarArquivarDocumento]", eventName, payload);
}

function VerticalButtons({ handleMoveTableRow, disabled }) {
  return (
    <div
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <IconButton
        disabled={disabled}
        onClick={() => handleMoveTableRow("first")}
      >
        <KeyboardDoubleArrowUpIcon />
      </IconButton>
      <IconButton
        disabled={disabled}
        onClick={() => handleMoveTableRow("previous")}
      >
        <KeyboardArrowUpIcon />
      </IconButton>
      <IconButton
        disabled={disabled}
        onClick={() => handleMoveTableRow("next")}
      >
        <KeyboardArrowDownIcon />
      </IconButton>
      <IconButton
        disabled={disabled}
        onClick={() => handleMoveTableRow("last")}
      >
        <KeyboardDoubleArrowDownIcon />
      </IconButton>
    </div>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {children}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function TabProperties({
  documentTypeList,
  handleChangeDocumentType,
  handleChangeMetadados,
  handleChangeConfigFields,
  handleChangeDocumentos,
  jsonConfig,
  documentTableRow,
  handleSelectDocumentTableRow,
  handleMoveDocumentTableRow,
  metadadoTableRow,
  handleSelectMetadadoTableRow,
  handleMoveMetadadoTableRow,
  taskFields,
  businessObject,
}) {
  const documentType = jsonConfig?.documentType || "";
  const documentTitle = jsonConfig?.documentTitle || "";
  const documentResult = jsonConfig?.documentResult || "";
  const documentos = jsonConfig?.documentos || [];
  let documentVariables = getDocumentoVariables(taskFields) || [];
  documentVariables = documentVariables.concat(
    getUniqueDocumentServiceFields(businessObject),
  );

  documentVariables = documentVariables.filter((value, index, self) => {
    return index === self.findIndex((obj) => obj.id === value.id);
  });

  const metadados = jsonConfig?.metadados || [];
  const metadadosSelecteds = metadados.map((m) => {
    const findMet = taskFields?.find((taskField) => taskField.id === m);
    const label =
      getUnitPropertie(findMet?.properties, "label") || findMet?.label;

    return {
      id: m,
      label,
    };
  });

  const metadadosList =
    (taskFields &&
      taskFields
        .filter(
          (taskField) =>
            !documentVariables.some((docItem) => docItem.id === taskField.id),
        )
        .map((taskField) => {
          return {
            id: taskField.id,
            label: taskField.name,
          };
        })) ||
    [];

  const documentosList = documentVariables.map((doc) => {
    return {
      variableId: doc.id,
      properties: {
        isMainFile: false,
      },
      name: doc.name,
    };
  });

  const clickableCell = (row, content) => {
    return (
      <Box
        onClick={(event) => {
          event.stopPropagation();
          handleSelectDocumentTableRow(row);
        }}
        sx={{
          cursor: "pointer",
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          minHeight: 32,
        }}
      >
        {content}
      </Box>
    );
  };

  const documentosTable = {
    headers: [
      {
        title: "",
        field: " ",
        type: "extra",
        flex: 0.5,
        hideCheckbox: true,
        render: (row) => {
          const checked = row?.variableId === documentTableRow?.variableId;

          return (
            <Box
              onClick={(event) => {
                event.stopPropagation();
                handleSelectDocumentTableRow(row);
              }}
              sx={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: "100%",
                minHeight: 32,
              }}
            >
              <Checkbox
                checked={checked}
                onClick={(event) => event.stopPropagation()}
                onChange={(event) => {
                  event.stopPropagation();
                  handleSelectDocumentTableRow(row);
                }}
              />
            </Box>
          );
        },
      },
      {
        title: language.orderInTheSet,
        field: "principal",
        type: "extra",
        flex: 1,
        hideCheckbox: true,
        render: (row) => {
          const label =
            row?.tableData?.id === 0 ? language.Main : row?.tableData?.id + 1;
          return clickableCell(
            row,
            <Typography variant="body2">{label}</Typography>,
          );
        },
      },
      {
        title: language.ID,
        field: "variableId",
        flex: 1,
        hideCheckbox: true,
        render: (rowData) => {
          return clickableCell(
            rowData,
            <Typography variant="body2">{rowData.variableId}</Typography>,
          );
        },
      },
      {
        title: language.label,
        field: "label",
        flex: 1,
        hideCheckbox: true,
        render: (rowData) => {
          return clickableCell(
            rowData,
            <Typography variant="body2">{rowData.name}</Typography>,
          );
        },
      },
    ],
    data: documentos,
  };

  const metadadosTable = {
    headers: [
      {
        title: language.orderInTheSet,
        field: "principal",
        type: "extra",
        flex: 1,
        hideCheckbox: true,
        render: (row) => {
          return (
            <Typography variant="body2">{row?.tableData?.id + 1}</Typography>
          );
        },
      },
      {
        title: language.ID,
        field: "id",
        flex: 1,
        hideCheckbox: true,
        render: (rowData) => {
          return <Typography variant="body2">{rowData.id}</Typography>;
        },
      },
      {
        title: language.label,
        field: "label",
        flex: 1,
        hideCheckbox: true,
        render: (rowData) => {
          return <Typography variant="body2">{rowData.label}</Typography>;
        },
      },
    ],
    data: metadadosSelecteds,
  };

  const tableOverride = {
    Toolbar: (props) => <Empty />,
  };

  const disableMove = !documentTableRow;

  return (
    <Grid container spacing={5} sx={{ marginY: 3 }}>
      <Grid item size={12}>
        <TextField
          select
          label={language.documentType}
          variant="outlined"
          id="documentType"
          name="documentType"
          inputProps={{
            id: "",
          }}
          value={documentType}
          onChange={handleChangeDocumentType}
          fullWidth
        >
          <MenuItem value="">
            <em></em>
          </MenuItem>
          {documentTypeList &&
            documentTypeList.map((item) => {
              return (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              );
            })}
        </TextField>
      </Grid>

      <Grid item size={12}>
        <TextField
          required
          id="outlined-basic"
          name="documentTitle"
          label={language.Title}
          value={documentTitle}
          onChange={handleChangeConfigFields}
          variant="outlined"
          fullWidth
        />
      </Grid>

      <Grid item size={12}>
        <TextField
          required
          id="outlined-basic"
          name="documentResult"
          label={language.id}
          value={documentResult}
          onChange={handleChangeConfigFields}
          variant="outlined"
          fullWidth
        />
      </Grid>

      <Grid item size={12}>
        <Autocomplete
          value={documentos}
          onChange={handleChangeDocumentos}
          multiple
          id="file-list"
          options={documentosList}
          getOptionLabel={(fileField) => fileField.variableId}
          filterSelectedOptions
          getOptionSelected={(option, value) =>
            option.variableId === value.variableId
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              required
              fullWidth
              label={language.documentsForRegister}
            />
          )}
        />
      </Grid>

      {documentos?.length > 0 && (
        <Grid item size={12} container spacing={2}>
          <Grid item size={11}>
            <Table
              tableData={documentosTable}
              component_override={tableOverride}
              custom_option={{
                selection: false,
                showSelectAllCheckbox: false,
                showTextRowsSelected: false,
                rowStyle: (rowData) => ({
                  backgroundColor:
                    rowData.variableId === documentTableRow?.variableId
                      ? "#e8e8e8"
                      : "#FFFFFF",
                }),
              }}
              onClickRow={(...args) => handleSelectDocumentTableRow(...args)}
            />
          </Grid>

          <Grid item size={1}>
            <VerticalButtons
              disabled={disableMove}
              handleMoveTableRow={handleMoveDocumentTableRow}
            />
          </Grid>
        </Grid>
      )}

      <Grid item size={12}>
        <Autocomplete
          value={metadadosSelecteds}
          onChange={handleChangeMetadados}
          multiple
          id="metadados-list"
          name="metadados-list"
          options={metadadosList || []}
          getOptionLabel={(metadadoField) => metadadoField.id}
          filterSelectedOptions
          getOptionSelected={(option, value) => option.id === value.id}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              fullWidth
              label={language.indexMetadataContent}
            />
          )}
        />
      </Grid>

      {metadadosSelecteds?.length > 0 && (
        <Grid item size={12} container spacing={2}>
          <Grid item size={11}>
            <Table
              tableData={metadadosTable}
              component_override={tableOverride}
              custom_option={{
                selection: false,
                showSelectAllCheckbox: false,
                showTextRowsSelected: false,
                rowStyle: (rowData) => ({
                  backgroundColor:
                    rowData.id === metadadoTableRow?.id ? "#e8e8e8" : "#FFFFFF",
                }),
              }}
              onClickRow={(...args) => handleSelectMetadadoTableRow(...args)}
            />
          </Grid>

          <Grid item size={1}>
            <VerticalButtons
              disabled={!metadadoTableRow}
              handleMoveTableRow={handleMoveMetadadoTableRow}
            />
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}

const TreeNode = ({
  node,
  level = 0,
  expandedNodes,
  loadingNodes,
  selectedNodeId,
  onToggle,
  onSelectNode,
  allNodes,
}) => {
  const nodeData = allNodes[node.id];
  const isFolder = nodeData.type.name === "Folder";
  const isExpanded = expandedNodes.has(node.id);
  const isLoading = loadingNodes.has(node.id);
  const isSelected = selectedNodeId === node.id;

  const getIcon = () => {
    if (isLoading) {
      return <CircularProgress size={20} />;
    }
    if (isFolder) {
      return isExpanded ? <FolderOpenIcon /> : <FolderIcon />;
    }
    return isExpanded ? <DesktopWindowsOutlinedIcon /> : <DesktopWindowsIcon />;
  };

  return (
    <>
      <ListItem disablePadding sx={{ pl: level * 2 }}>
        <ListItemButton
          selected={isSelected}
          onClick={() => onSelectNode(nodeData)}
          sx={{
            minHeight: 40,
            "&.Mui-selected": {
              backgroundColor: "primary.light",
              "&:hover": {
                backgroundColor: "primary.light",
              },
            },
          }}
        >
          <ListItemIcon sx={{ minWidth: 36 }}>{getIcon()}</ListItemIcon>
          <ListItemText
            primary={nodeData.name}
            primaryTypographyProps={{ variant: "body2" }}
          />
          <Box
            onClick={(e) => {
              e.stopPropagation();
              onToggle(node);
            }}
            sx={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              p: 0.5,
              borderRadius: 1,
              "&:hover": {
                backgroundColor: "action.hover",
              },
            }}
          >
            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </Box>
        </ListItemButton>
      </ListItem>
      {node.children && (
        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {node.children.map((child) => (
              <TreeNode
                key={child.id}
                node={child}
                level={level + 1}
                expandedNodes={expandedNodes}
                loadingNodes={loadingNodes}
                selectedNodeId={selectedNodeId}
                onToggle={onToggle}
                onSelectNode={onSelectNode}
                allNodes={allNodes}
              />
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
};

function TabConfiguration({
  jsonConfig,
  handleChangeConfigFields,
  handleSelectFolder,
}) {
  const documentPath = jsonConfig?.documentPath || "";

  const {
    loading,
    treeData,
    allNodes,
    expandedNodes,
    selectedNode,
    loadingNodes,
    handleToggle,
    handleSelectNode,
  } = useTreeFolder();

  useEffect(() => {
    if (!treeData.length && !selectedNode) {
      return;
    }
    handleSelectFolder(allNodes, selectedNode);
  }, [allNodes, selectedNode]);

  return (
    <Grid container spacing={2} sx={{ marginY: 3 }}>
      <Grid item size={12}>
        <Typography variant="h6">{language.documentStorageLocation}</Typography>
        <InputLabel>{language.navigateTreeAndSelect}</InputLabel>
        <InputLabel>{language.startByRepository}</InputLabel>
      </Grid>
      <Grid item size={12}>
        {loading ? (
          <CircularProgress size={16} />
        ) : (
          <div style={{ width: "100%" }}>
            {treeData.map((node) => (
              <TreeNode
                key={node.id}
                node={node}
                expandedNodes={expandedNodes}
                loadingNodes={loadingNodes}
                selectedNode={selectedNode}
                onToggle={handleToggle}
                onSelectNode={handleSelectNode}
                allNodes={allNodes}
              />
            ))}
          </div>
        )}
      </Grid>

      <Grid item size={12}>
        <Typography variant="body1">
          {language.createFolderOnSelectedLevel}
        </Typography>
      </Grid>

      <Grid item size={12}>
        <TextField
          required
          id="documentPath"
          name="documentPath"
          label={language.pathUntilFolder}
          value={documentPath}
          onChange={handleChangeConfigFields}
          variant="outlined"
          fullWidth
        />
      </Grid>
    </Grid>
  );
}

function OverrideModalActions(props) {
  const { handleSubmit, handleClose } = props;
  return (
    <DialogActions>
      <ButtonGroup>
        <Button
          variant="outlined"
          size="large"
          color="primary"
          onClick={handleClose}
        >
          {language.cancel}
        </Button>
        <Button
          variant="contained"
          size="large"
          color="primary"
          onClick={handleSubmit}
        >
          {language.save}
        </Button>
      </ButtonGroup>
    </DialogActions>
  );
}

const REGISTRAR_DOCUMENT_INITIAL_VALUE = {
  folderTree: [],
  files: [],
  metadados: [],
  documentResult: "",
  documentTitle: "",
  documentType: null,
  documentPath: "",
};

function ModelerModalRegistrarArquivarDocumento({
  saveRegistrarArquivarDocumentoConfig,
  businessObject,
  element,
  extensionElements,
  bpmnFactory,
  FormComponents,
  inputValues,
  menuTree,
  menuExpanded,
  menuHighlighted,
}) {
  const [state, setState] = useState({
    fullWidth: true,
    maxWidth: "md",
    tabValue: 0,
    folderSelected: [],
    currentFolderSelected: false,
  });
  const [jsonConfig, setJsonConfig] = useState({
    ...REGISTRAR_DOCUMENT_INITIAL_VALUE,
  });
  const [documentTableRow, setDocumentTableRow] = useState(null);
  const [metadadoTableRow, setMetadadoTableRow] = useState(null);
  const [hasConfigError, setHasConfigError] = useState(false);
  const [open, setOpen] = useState(true);

  const { data: documentTypeList } = useDocumentTypes({
    params: {
      isPageable: false,
    },
  });

  useEffect(() => {
    const documentos = jsonConfig?.documentos || [];
    if (documentos.length === 0) {
      if (documentTableRow) {
        setDocumentTableRow(null);
      }
      return;
    }

    if (documentTableRow?.variableId) {
      const stillExists = documentos.some(
        (docItem) => docItem?.variableId === documentTableRow.variableId,
      );
      if (!stillExists) {
        setDocumentTableRow(null);
      }
    }
  }, [jsonConfig?.documentos, documentTableRow]);

  useEffect(() => {
    if (inputValues) {
      setJsonConfig({
        folderTree: inputValues?.folderTree,
        documentPath: inputValues?.folderTree?.join("/"),
        documentos: inputValues?.files,
        metadados: inputValues?.metadados,
        documentResult: inputValues?.documentResult,
        documentTitle: inputValues?.documentTitle,
        documentType: inputValues?.documentType,
      });
    }

    setState((prev) => ({
      ...prev,
      folderSelected: menuHighlighted,
    }));
  }, [inputValues, menuHighlighted, menuTree, menuExpanded]);

  const validateConfig = (obj) => {
    const erros = [];

    if (!obj.documentType) {
      erros.push(language.documentTypeIsRequired);
    }

    if (!obj.documentTitle || obj.documentTitle.trim().length <= 0) {
      erros.push(language.documentTitleIsRequired);
    }

    if (!obj.documentResult || obj.documentResult.trim().length <= 0) {
      erros.push(language.documentIdIsRequired);
    }

    if (!obj.files || obj.files.length <= 0) {
      erros.push(language.documentIsRequired);
    }

    if (!obj.folderTree || obj.folderTree.length <= 0) {
      erros.push(language.storagePathIsRequired);
    }

    return erros;
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangeTab = (event, newValue) => {
    setState((prev) => ({
      ...prev,
      tabValue: newValue,
    }));
  };

  const handleSave = () => {
    const folderTree =
      jsonConfig?.documentPath?.trim().length > 0
        ? jsonConfig?.documentPath?.trim().split("/")
        : [];

    const files =
      (jsonConfig?.documentos || []).map((doc, index) => {
        return {
          variableId: doc.variableId,
          properties: {
            isMainFile: index === 0,
          },
          name: doc.name,
        };
      }) || [];

    const metadados = jsonConfig?.metadados || [];
    const documentResult = jsonConfig?.documentResult;
    const documentTitle = jsonConfig?.documentTitle;
    const documentType = jsonConfig?.documentType;

    const inputObject = {
      folderTree,
      files,
      metadados,
      documentResult,
      documentTitle,
      documentType,
    };

    const erros = validateConfig(inputObject);
    if (erros.length > 0) {
      setHasConfigError(erros);
      return;
    }

    saveRegistrarArquivarDocumentoConfig(
      businessObject,
      element,
      extensionElements,
      bpmnFactory,
      inputObject,
    );

    handleClose();
  };

  const handleChangeDocumentType = (event) => {
    const { value } = event.target;
    setJsonConfig((prev) => ({
      ...prev,
      documentType: value,
    }));
  };

  const handleChangeMetadados = (event, newValue) => {
    const values = newValue?.map((v) => v.id) || [];
    setJsonConfig((prev) => ({
      ...prev,
      metadados: values,
    }));
    setMetadadoTableRow(null);
  };

  const collectObjectsFromArgs = (args) => {
    const collected = [];

    for (const argument of args) {
      if (!argument || typeof argument !== "object") {
        continue;
      }

      collected.push(argument);

      if (argument.rowData && typeof argument.rowData === "object") {
        collected.push(argument.rowData);
      }
      if (argument.data && typeof argument.data === "object") {
        collected.push(argument.data);
      }
    }

    return collected;
  };

  const resolveDocumentRowFromArgs = (...args) => {
    const candidates = collectObjectsFromArgs(args);

    const byVariableId = candidates.find(
      (candidate) =>
        typeof candidate.variableId === "string" && candidate.variableId,
    );
    if (byVariableId) {
      return byVariableId;
    }

    const byTableIndex = candidates
      .map((candidate) => candidate?.tableData?.id)
      .find((tableIndex) => Number.isInteger(tableIndex));

    if (Number.isInteger(byTableIndex)) {
      const resolved = (jsonConfig?.documentos || [])[byTableIndex];
      if (resolved && typeof resolved === "object") {
        return resolved;
      }
    }

    return null;
  };

  const resolveMetadadoRowFromArgs = (...args) => {
    const candidates = collectObjectsFromArgs(args);

    const byId = candidates.find(
      (candidate) => typeof candidate.id === "string" && candidate.id,
    );
    if (byId) {
      return byId;
    }

    return null;
  };

  const handleSelectMetadadoTableRow = (...args) => {
    const row = resolveMetadadoRowFromArgs(...args);
    if (!row) {
      return;
    }

    if (metadadoTableRow?.id === row.id) {
      setMetadadoTableRow(null);
      return;
    }

    setMetadadoTableRow(row);
  };

  const handleSelectDocumentTableRow = (...args) => {
    const row = resolveDocumentRowFromArgs(...args);
    if (!row) {
      return;
    }

    if (documentTableRow?.variableId === row.variableId) {
      setDocumentTableRow(null);
      return;
    }

    setDocumentTableRow(row);
  };

  const handleMoveMetadadoTableRow = (button, row) => {
    const targetRow = row || metadadoTableRow;
    const currentList = jsonConfig?.metadados || [];

    if (!targetRow || currentList.length <= 1) {
      return;
    }

    const fromIndex = currentList.findIndex((id) => id === targetRow.id);

    if (fromIndex === -1) {
      return;
    }

    const metadados = [...currentList];
    const [moved] = metadados.splice(fromIndex, 1);

    let toIndex = fromIndex;

    if (button === "first") {
      toIndex = 0;
    } else if (button === "previous") {
      toIndex = Math.max(0, fromIndex - 1);
    } else if (button === "next") {
      toIndex = Math.min(metadados.length, fromIndex + 1);
    } else if (button === "last") {
      toIndex = metadados.length;
    }

    metadados.splice(toIndex, 0, moved);

    setJsonConfig((prev) => ({
      ...prev,
      metadados,
    }));

    setMetadadoTableRow({ ...targetRow });
  };

  const handleChangeConfigFields = (event) => {
    const { name, value } = event.target;
    setJsonConfig((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeDocumentos = (event, newValue) => {
    const map = new Map();
    for (const docItem of newValue || []) {
      const key = docItem?.variableId ?? JSON.stringify(docItem);
      if (map.has(key)) {
        map.delete(key);
      }
      map.set(key, docItem);
    }
    const deduped = Array.from(map.values());

    setJsonConfig((prev) => ({
      ...prev,
      documentos: deduped,
    }));

    const selectedId = documentTableRow?.variableId;
    if (selectedId) {
      const stillExists = deduped.some(
        (docItem) => docItem?.variableId === selectedId,
      );
      if (!stillExists) {
        setDocumentTableRow(null);
      }
    }
  };

  const handleMoveDocumentTableRow = (button, row) => {
    const targetRow = row || documentTableRow;
    const currentList = jsonConfig?.documentos || [];

    if (!targetRow || currentList.length <= 1) {
      return;
    }

    const fromIndex = currentList.findIndex(
      (doc) => doc?.variableId === targetRow.variableId,
    );

    if (fromIndex === -1) {
      return;
    }

    const documentos = [...currentList];
    const [moved] = documentos.splice(fromIndex, 1);

    const maxInsertIndex = documentos.length;
    let toIndex = fromIndex;

    if (button === "first") {
      toIndex = 0;
    } else if (button === "previous") {
      toIndex = Math.max(0, fromIndex - 1);
    } else if (button === "next") {
      toIndex = Math.min(maxInsertIndex, fromIndex + 1);
    } else if (button === "last") {
      toIndex = maxInsertIndex;
    }

    documentos.splice(toIndex, 0, moved);

    setJsonConfig((prev) => ({
      ...prev,
      documentos,
    }));

    setDocumentTableRow(moved);
  };

  const handleSelectFolder = (allNodes, selectedNode) => {
    if (!selectedNode) {
      return;
    }

    const foldersNames = selectedNode.path
      .split("/")
      .filter(Boolean)
      .map((folder) => {
        if (folder) {
          return allNodes[folder].name;
        }
        return folder;
      });

    setJsonConfig((prev) => ({
      ...prev,
      folderTree: foldersNames,
      documentPath: foldersNames.join("/"),
    }));
  };

  const { tabValue } = state;

  return (
    open && (
      <GenericModal
        title={language.configuration}
        handleClose={handleClose}
        size={state.maxWidth}
        bigHeight
        open={true}
        handleSubmit={handleSave}
        btnActionTitle={language.save}
        btnCancelTitle={language.cancel}
        overrideDialogActions={() =>
          OverrideModalActions({
            handleSubmit: handleSave,
            handleClose,
          })
        }
      >
        <Tabs
          value={tabValue}
          indicatorColor="secondary"
          textColor="secondary"
          onChange={handleChangeTab}
        >
          <Tab label={language.properties} />
          <Tab label={language.configuration} />
          <Tab label={language.permissions} disabled />
        </Tabs>

        <FormPadding>
          <TabPanel value={tabValue} index={0}>
            <TabProperties
              businessObject={businessObject}
              taskFields={FormComponents}
              jsonConfig={jsonConfig}
              documentTypeList={documentTypeList?.content || []}
              handleChangeDocumentType={handleChangeDocumentType}
              handleChangeMetadados={handleChangeMetadados}
              handleChangeConfigFields={handleChangeConfigFields}
              handleChangeDocumentos={handleChangeDocumentos}
              documentTableRow={documentTableRow}
              handleSelectDocumentTableRow={handleSelectDocumentTableRow}
              handleMoveDocumentTableRow={handleMoveDocumentTableRow}
              metadadoTableRow={metadadoTableRow}
              handleSelectMetadadoTableRow={handleSelectMetadadoTableRow}
              handleMoveMetadadoTableRow={handleMoveMetadadoTableRow}
            />
          </TabPanel>

          <TabPanel value={tabValue} index={1}>
            <TabConfiguration
              handleSelectFolder={handleSelectFolder}
              jsonConfig={jsonConfig}
              handleChangeConfigFields={handleChangeConfigFields}
            />
          </TabPanel>
        </FormPadding>

        {hasConfigError && (
          <GenericSnackbar
            errorWithChildren={true}
            message={
              <div>
                {hasConfigError.map((err, index) => {
                  return <div key={`errorMessage_${index}`}>{err}</div>;
                })}
              </div>
            }
            handleClose={() => setHasConfigError(false)}
            duration={4000}
          />
        )}
      </GenericModal>
    )
  );
}

export default ModelerModalRegistrarArquivarDocumento;
